var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row text--base"},[_c('Firms',{attrs:{"content":_vm.firmsContent}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }